import { render } from "./CreateProductPage.vue?vue&type=template&id=61542fd3&scoped=true"
import script from "./CreateProductPage.vue?vue&type=script&lang=js"
export * from "./CreateProductPage.vue?vue&type=script&lang=js"

import "./CreateProductPage.vue?vue&type=style&index=0&id=61542fd3&lang=css"
import "./CreateProductPage.vue?vue&type=style&index=1&id=61542fd3&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61542fd3"]])

export default __exports__